/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_Success_VerificationInputs */

const en_directory_agent_readiness_check_success_verification = /** @type {(inputs: Directory_Agent_Readiness_Check_Success_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success verification`)
};

const zh_directory_agent_readiness_check_success_verification = /** @type {(inputs: Directory_Agent_Readiness_Check_Success_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成功状态验证`)
};

/**
* | output |
* | --- |
* | "Success verification" |
*
* @param {Directory_Agent_Readiness_Check_Success_VerificationInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_success_verification = /** @type {((inputs?: Directory_Agent_Readiness_Check_Success_VerificationInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_Success_VerificationInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_success_verification(inputs)
	return zh_directory_agent_readiness_check_success_verification(inputs)
});
export { directory_agent_readiness_check_success_verification as "directory.agent_readiness.check.success_verification" }